module.exports = __webpack_public_path__ + "static/media/s3-alt-no-va.16ac749b.png";